import classNames from 'classnames';
import type { AvatarProps } from 'components/Avatar';
import Avatar from 'components/Avatar';
import React from 'react';
import styles from './Avatar.module.scss';

interface AvatarStackUser {
  id?: number;
  name: string;
  avatar?: { medium_retina: string | null | undefined };
}

interface Props {
  users?: Array<AvatarStackUser>;
  maxItems?: number;
  className?: string;
  size?: AvatarProps['size'];
}

const AvatarStack = ({ users = [], maxItems = 5, className, size }: Props) => {
  const avatarList = users
    .slice(0, maxItems)
    // To get "folded on top of" effect, we're showing DOM elements in reverse order
    // and reversing the array here to offset that
    .reverse()
    .map((user, index) => {
      const avatar = user.avatar?.medium_retina;
      return (
        <Avatar
          key={user.id ?? `avatarStack-${index}`}
          fallbackToInitials
          shape="circle"
          size={size}
          name={user.name}
          src={avatar}
        />
      );
    });

  const numAdditionalAvatars = users.length > maxItems ? users.length - maxItems : null;

  const containerClass = classNames(styles.stack, className);
  return (
    <div className={containerClass}>
      {numAdditionalAvatars && (
        <div className={styles.additionalCount}>+{numAdditionalAvatars}</div>
      )}
      {avatarList}
    </div>
  );
};

export default AvatarStack;
